import type { Resource } from '../../';
export const language_es: Resource = {"default":"Spanish"};
